
import "./content_view.css"
import DashBoardAPIItem from "../../../dashboard_api_item";
import JsonView from '@uiw/react-json-view';
import CustomCodeBlock from "./code_block";
import { githubDarkTheme } from '@uiw/react-json-view/githubDark';







const ContentView = ({section_info,page,sectionMap, subTitle}) =>{

    const testAPIResponse = 
    [
        {
          "userId": 1,
          "id": 1,
          "title": "sunt aut facere repellat provident occaecati excepturi optio reprehenderit",
          "body": "quia et suscipit\nsuscipit recusandae consequuntur expedita et cum\nreprehenderit molestiae ut ut quas totam\nnostrum rerum est autem sunt rem eveniet architecto"
        },
        {
          "userId": 1,
          "id": 2,
          "title": "qui est esse",
          "body": "est rerum tempore vitae\nsequi sint nihil reprehenderit dolor beatae ea dolores neque\nfugiat blanditiis voluptate porro vel nihil molestiae ut reiciendis\nqui aperiam non debitis possimus qui neque nisi nulla"
        },
        {
          "userId": 1,
          "id": 3,
          "title": "ea molestias quasi exercitationem repellat qui ipsa sit aut",
          "body": "et iusto sed quo iure\nvoluptatem occaecati omnis eligendi aut ad\nvoluptatem doloribus vel accusantium quis pariatur\nmolestiae porro eius odio et labore et velit aut"
        },
        {
          "userId": 1,
          "id": 4,
          "title": "eum et est occaecati",
          "body": "ullam et saepe reiciendis voluptatem adipisci\nsit amet autem assumenda provident rerum culpa\nquis hic commodi nesciunt rem tenetur doloremque ipsam iure\nquis sunt voluptatem rerum illo velit"
        }
    ]

    const code = `
        import requests
        url = "https://test.com/${section_info[sectionMap[subTitle]].full_endpoint}?ticker=AMZN&authorization=API_TOKEN"
        result = requests.get(url)
        parseData = result.json()
        `
    ;



      
    return(
        <div className="api_content_view_bottom">
            {
            page.toLowerCase() == 'overview' && 
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="left-container-setup">
                    <h2 className="api_content_view_title">{section_info[sectionMap[subTitle]].title}: </h2>
                    <p>
                       <strong>Disclaimer:</strong> The data provided by stockarchives / stockarchives-api is for 
                       informational purposes only and should not be relied on for investment decisions.
                        We are not responsible for any financial losses, gains, 
                        or other outcomes resulting from use of this data, including 
                        inaccuracies or misinterpretations. For official and most accurate information, 
                        please consult trusted sources such as the <a href="https://www.sec.gov/search-filings" 
                        target="_blank" rel="noopener noreferrer"><strong>SEC</strong></a> and company investor
                         relations websites.
                    </p>
                </div>
                
                <div className="section-placeholder-dashboard-item-setup">
                    <p>
                        <strong>1. Access the API </strong>  
                        Use the Base URL (e.g. `https://stockarchives-api.com`) 
                        to construct your requests.</p>
        
                    <p>
                        <strong>2. Obtaining Your API Key </strong>  
                        Navigate to your profile and click “Generate API Key.”  
                        <em>Important: </em> 
                        Copy and securely store your API key immediately — it will not be shown again. If lost, you'll need to generate a new one.
                        </p>
        
                    <p>
                        <strong>3. Make Requests </strong>  
                        Use tools like Postman, cURL, or Insomnia to send requests to the API. 
                        Include your API key in 
                        the `Authorization` parameter for authentication.
                    </p>
                </div>
            </div>
            } 
            {
                page.toLowerCase() != 'overview' && 
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div className="left-container">
                        <h2 className="api_content_view_title">{section_info[sectionMap[subTitle]].title}: </h2>

                        <div className="api-endpoint-container">
                            <div className="api-endpoint-container-items-left">
                                {section_info[sectionMap[subTitle]].type}
                            </div>
                            <div className="api-endpoint-container-items-right">
                            {section_info[sectionMap[subTitle]].full_endpoint}
                            </div>
                        </div>


                        <div className="api-section-whole">
                            <h4 className="api-section-header" style={{width:"100%"}}>Source: </h4>
                            <div className="api-section-divider" style={{width:"100%",height:"20"}}>
                                {section_info[sectionMap[subTitle]].source}
                            </div>
                        </div>
                        <div className="api-section-whole">
                            <h4 className="api-section-header" style={{width:"100%"}}>Overview: </h4>
                            <div className="api-section-divider" style={{width:"100%",height:"20"}}>
                                {section_info[sectionMap[subTitle]].overview}
                            </div>
                        </div> 

                        <div className="api-section-whole">
                            <h4 className="api-section-header" style={{width:"100%"}}>Request Fields: </h4>
                            <div className="api-section-divider" style={{width:"100%",height:"20"}}>
                                {section_info[sectionMap[subTitle]].request_fields.map((item,index)=>(
                                    <div style={{marginBottom:"10px"}}>   
                                        <div>{item.title}: </div>
                                        <div>{item.fields}</div>
                                        <div>{item.explanation}</div>
                                        <div>{item.example}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                    
                    <div className="section-placeholder-dashboard-item">
                        <div className="json_code_block_outer">
                            <div className="json_code_block">
                                Code: 
                            </div>
                            <CustomCodeBlock code={code} />
                        </div>
                        <div className="json_view_container_outer">
                            <div className="json_response">Response: </div>
                            <JsonView   
                                className="json_view_container"
                                style={githubDarkTheme}   // 👈 THIS is the correct usage
                                value={section_info[sectionMap[subTitle]].api_response}

                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default ContentView;